/* global axios */
import ApiClient from './ApiClient';

const toQueryString = params => {
  const query = new URLSearchParams(
    Object.entries(params).filter(([, value]) => value !== '' && value != null)
  ).toString();

  return query ? `?${query}` : '';
};

class AgentRelationshipsAPI extends ApiClient {
  constructor() {
    super('agent_relationships', { accountScoped: true });
  }

  list(params = {}) {
    return axios.get(`${this.url}${toQueryString(params)}`);
  }

  me(params = {}) {
    return axios.get(`${this.baseUrl()}/agents/me${toQueryString(params)}`);
  }

  shopwindow(id, payload = {}) {
    return axios.patch(`${this.url}/${id}/shopwindow`, payload);
  }

  keysWithAgent(imovelId) {
    return axios.get(
      `${this.baseUrl()}/imoveis/${imovelId}/entry_accesses/keys_with_agent`
    );
  }
}

export default new AgentRelationshipsAPI();
